import { createSlice } from '@reduxjs/toolkit'

export const orderSlice = createSlice({
  name: 'programs',
  initialState: {
    order: null
  },
  reducers: {
    setOrder: (state, action) => {
      const { payload } = action
      state.order = payload
    },
  }
})
export const { setOrder } = orderSlice.actions

export default orderSlice.reducer
